import appConfigStoreModule from '@core/@app-config/appConfigStoreModule'
import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'
import loader from './system/loader'
import errors from './system/errors'
import auth from './system/auth'
import users from './system/users'
import data from './system/data'

// Custom
import bookings from './custom/bookings'
import notes from './custom/notes'
import payments from './custom/payments'
import addOns from './custom/addOns'
import promos from './custom/promos'
import events from './custom/events'
import cronJob from './custom/cronJob'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    appConfig: appConfigStoreModule,
    app,
    loader,
    errors,
    auth,
    users,
    data,

    // Custom
    bookings,
    notes,
    payments,
    addOns,
    promos,
    events,
    cronJob,

  },
})
